import React, {useState} from 'react';
import {EditorState,convertToRaw} from "draft-js";
import {Editor} from "react-draft-wysiwyg";
import './css/text-editor.css'
import '../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from "draftjs-to-html";
import DOMPurify from "dompurify";



function TextEditor(props) {
  const [editorState,setSditorState] = useState(EditorState.createEmpty());
  const onEditorStateChange = (editorState) => {
    const draftToHtmlString = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    props.handleChange(DOMPurify.sanitize(draftToHtmlString));
    setSditorState(editorState);
  };

  return (
    <>
       <Editor
        editorState={editorState}
        wrapperClassName="wrapper-class"
        editorClassName="editor-class"
        toolbarClassName="toolbar-class"
        onEditorStateChange={onEditorStateChange}    
        // toolbar={{
        //   inline: { inDropdown: true },
        //   list: { inDropdown: true },
        //   textAlign: { inDropdown: true },
        //   link: { inDropdown: true },
        //   history: { inDropdown: true },
        // }}
      />
    </>
  )
}
export default TextEditor;
